{
	"Spanish": {
		"Greetings": "Esto es lo que puede esperar de", 
		"releaseVersion": "Versión 24.4",
		"acknowledge": "Gracias",
		"General": "General", 
		"Messaging": "Mensajería", 
		"Gamification": "Gamificación", 
		"Coaching": "Entrenamiento", 
		"QA": "Control de Calidad", 
		"Dashboards": "Tableros", 
		"Wallboards": "Tableros de pared",
		"Notes": 
			{
			"General": [
				"Exportación de jerarquía",
                "Mejoras en la suscripción",
                "Configuración del widget modal heredado al final de su vida útil: reemplazada por configuración deslizable"
			],
			"Messaging": [], 
			"Gamification": [
				"Nuevo tipo de desafío: Barcos de batalla"
			], 
			"Coaching": [
                "Agregar columnas a la página de informes de administración de coaching",
                "Agregar fecha de vencimiento como campo opcional en la sesión de coaching",
                "Agregar fecha de vencimiento como campo opcional en las tareas dentro de la sesión de coaching",
                "Enviar notificaciones por correo electrónico sobre eventos de coaching",
                "Nueva columna de nombre de sesión de coaching y opción de exportación y filtro de tareas vencidas",
                "Actualización de la página del formulario (tipo de respuesta de selección múltiple)"
			], 
			"QA": [], 
			"Dashboards": [
				"Mejoras en las fechas preestablecidas del widget: vista del calendario gregoriano",
				"Nuevo widget: Mi widget de clasificación",
				"Carga inicial estandarizada de widgets",
				"Componente de barra de publicación actualizado",
                "Asignación de jerarquías: se agregaron nuevas columnas",
                "Actualización del rango de fechas: año móvil a 12 meses móviles"
			], 
			"Wallboards": [
                "Conversión a Angular para la vista y presentación de diapositivas"
			]
			},
		"DirectNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"NiceInContactNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"Five9Notes": 
			{
			"General": [
			],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"SerenovaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"GenesysNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"CiscoNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AmazonNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AvayaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"UJetNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			}
	},
	"French": {
		"Greetings": "Voici à quoi s'attendre de", 
		"releaseVersion": "Version 24.4",
		"acknowledge": "Merci",
		"General": "Général", 
		"Messaging": "Messagerie", 
		"Gamification": "Ludification", 
		"Coaching": "Entraînement", 
		"QA": "AQ", 
		"Dashboards": "Tableaux de bord", 
		"Wallboards": "Panneaux muraux",
		"Notes": 
			{
			"General": [
                "Exportation de hiérarchie",
                "Améliorations de l'abonnement",
                "Paramètres du widget modal hérité en fin de vie – Remplacés par les paramètres coulissants"
			],
			"Messaging": [], 
			"Gamification": [
				"Nouveau type de défi : Bataille navale"
			],
            "Coaching": [
                "Ajouter des colonnes à la page du rapport d'administration du coaching",
                "Ajouter la date d'échéance comme champ facultatif lors de la séance de coaching",
                "Ajouter la date d'échéance comme champ facultatif pour les tâches à l'intérieur de la session de coaching",
                "Envoyer des notifications par e-mail sur les événements de coaching",
                "Nouvelle colonne de nom de session de coaching et option de filtre et d'exportation des tâches en retard",
                "Mise à jour de la page du formulaire (type de réponse à sélection multiple)"
            ], 
			"QA": [],
            "Dashboards": [
                "Améliorations des dates prédéfinies du widget : affichage du calendrier grégorien",
                "Nouveau widget : Mon widget de classement",
                "Chargement initial standardisé du widget",
                "Composant de la barre de publication mis à jour",
                "Cartographie hiérarchique : nouvelles colonnes ajoutées",
                "Mise à jour de la plage de dates - Année glissante à 12 mois glissants"
            ], 
			"Wallboards": [
                "Conversion angulaire des panneaux muraux Vue/diaporama"
			]
			},
		"DirectNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"NiceInContactNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"Five9Notes": 
			{
			"General": [
			],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"SerenovaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"GenesysNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"CiscoNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AmazonNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AvayaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"UJetNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			}
	},
	"German": {
		"Greetings": "Das erwartet Sie", 
		"releaseVersion": "Freigeben 24.4",
		"acknowledge": "Vielen Dank",
		"General": "Allgemein", 
		"Messaging": "Nachrichtenübermittlung", 
		"Gamification": "Gamifizierung", 
		"Coaching": "Coaching", 
		"QA": "QA", 
		"Dashboards": "Dashboards", 
		"Wallboards": "Wallboards",
		"Notes": 
			{
            "General": [
                "Hierarchieexport",
                "Abonnement-Erweiterungen",
                "End of Life Legacy Modal Widget-Einstellungen – ersetzt durch Slide Out-Einstellungen"
            ],
			"Messaging": [
				
			], 
			"Gamification": [
				"Neuer Herausforderungstyp: Schlachtboote"
			],
            "Coaching": [
                "Spalten zur Coaching-Administratorberichtsseite hinzufügen",
                "Fälligkeitsdatum als optionales Feld zur Coaching-Sitzung hinzufügen",
                "Fälligkeitsdatum als optionales Feld für Aufgaben in der Coaching-Sitzung hinzufügen",
                "Senden Sie E-Mail-Benachrichtigungen zu Coaching-Events",
                "Neue Spalte mit dem Namen der Coaching-Sitzung und Filter- und Exportoption für überfällige Aufgaben",
                "Aktualisierung der Formularseite (Antworttyp mehrfach auswählen)"
            ], 
			"QA": [],
            "Dashboards": [
                "Verbesserungen bei voreingestellten Widget-Daten: Gregorianische Kalenderansicht",
                "Neues Widget: Mein Ranking-Widget",
                "Standardisiertes anfängliches Laden von Widgets",
                "Aktualisierte Veröffentlichungsleistenkomponente",
                "Hierarchiezuordnung: Neue Spalten hinzugefügt",
                "Aktualisierung des Datumsbereichs – rollierendes Jahr bis rollierende 12 Monate"
            ], 
			"Wallboards": [
                "Wallboards Angular Conversion Ansicht/Diashow"
			]
			},
		"DirectNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"NiceInContactNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"Five9Notes": 
			{
			"General": [
			],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"SerenovaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"GenesysNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"CiscoNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AmazonNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AvayaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"UJetNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			}
	},
	"CanadianFrench": {
		"Greetings": "Voici à quoi s'attendre de", 
		"releaseVersion": "Version 24.4",
		"acknowledge": "Merci",
		"General": "Général", 
		"Messaging": "Messagerie", 
		"Gamification": "Ludification", 
		"Coaching": "Entraînement", 
		"QA": "AQ", 
		"Dashboards": "Tableaux de bord", 
		"Wallboards": "Panneaux muraux",
		"Notes": 
			{
            "General": [
                "Exportation de hiérarchie",
                "Améliorations de l'abonnement",
                "Paramètres du widget modal hérité en fin de vie – Remplacés par les paramètres coulissants"
            ],
			"Messaging": [], 
			"Gamification": [
                "Nouveau type de défi : Bataille navale"
			],
            "Coaching": [
                "Ajouter des colonnes à la page du rapport d'administration du coaching",
                "Ajouter la date d'échéance comme champ facultatif lors de la séance de coaching",
                "Ajouter la date d'échéance comme champ facultatif pour les tâches à l'intérieur de la session de coaching",
                "Envoyer des notifications par e-mail sur les événements de coaching",
                "Nouvelle colonne de nom de session de coaching et option de filtre et d'exportation des tâches en retard",
                "Mise à jour de la page du formulaire (type de réponse à sélection multiple)"
            ], 
			"QA": [],
            "Dashboards": [
                "Améliorations des dates prédéfinies du widget : affichage du calendrier grégorien",
                "Nouveau widget : Mon widget de classement",
                "Chargement initial standardisé du widget",
                "Composant de la barre de publication mis à jour",
                "Cartographie hiérarchique : nouvelles colonnes ajoutées",
                "Mise à jour de la plage de dates - Année glissante à 12 mois glissants"
            ],
            "Wallboards": [
                "Conversion angulaire des panneaux muraux Vue/diaporama"
            ]
			},
		"DirectNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"NiceInContactNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"Five9Notes": 
			{
			"General": [
			],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"SerenovaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"GenesysNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"CiscoNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AmazonNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AvayaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"UJetNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			}
	},
	"BrazilianPortuguese": {
		"Greetings": "Aqui está o que esperar de", 
		"releaseVersion": "Versión 24.4",
		"acknowledge": "Obrigado",
		"General": "Em geral", 
		"Messaging": "Messagerie", 
		"Gamification": "Gamificação", 
		"Coaching": "Entraînement", 
		"QA": "CQ", 
		"Dashboards": "Painéis", 
		"Wallboards": "Painéis de parede",
		"Notes": 
			{
            "General": [
                "Exportação de Hierarquia",
                "Melhorias na assinatura",
                "Configurações do Widget Modal Legado de Fim de Vida – Substituído por Configurações de Slide Out"
            ],
			"Messaging": [],
            "Gamification": [
                "Novo tipo de desafio: Barcos de batalha"
            ],
            "Coaching": [
                "Adicionar colunas à página de relatório do administrador de coaching",
                "Adicionar data de vencimento como campo opcional na sessão de coaching",
                "Adicionar data de vencimento como um campo opcional em tarefas dentro da sessão de coaching",
                "Enviar notificações por e-mail sobre eventos de coaching",
                "Nova coluna de nome da sessão de coaching e filtro de tarefas atrasadas e opção de exportação",
                "Atualização da página do formulário (tipo de resposta de seleção múltipla)"
            ], 
			"QA": [],
            "Dashboards": [
                "Melhorias nas datas predefinidas do widget: Visualização do calendário gregoriano",
                "Novo Widget: Meu Widget de Classificação",
                "Carregamento de widget inicial padronizado",
                "Componente da barra de publicação atualizado",
                "Mapeamento de hierarquia: novas colunas adicionadas",
                "Atualização do intervalo de datas - Ano contínuo para 12 meses contínuos"
            ],
            "Wallboards": [
                "Wallboards Angular Conversão Visualização/Slideshow"
            ]
			},
		"DirectNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"NiceInContactNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"Five9Notes": 
			{
			"General": [
			],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"SerenovaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"GenesysNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"CiscoNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AmazonNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AvayaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"UJetNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			}
	},
	"Dutch": {
		"Greetings": "Hier leest u wat u ervan kunt verwachten", 
		"releaseVersion": "Uitgave 24.4",
		"acknowledge": "Bedankt",
		"General": "Algemeen", 
		"Messaging": "Messagerie", 
		"Gamification": "Gamificatie", 
		"Coaching": "Entraînement", 
		"QA": "QA", 
		"Dashboards": "Dashboards", 
		"Wallboards": "Wandplaten",
		"Notes": 
			{
            "General": [
                "Hiërarchie exporteren",
                "Verbeteringen aan abonnementen",
                "End Of Life Legacy Modal Widget-instellingen – Vervangen door Slide Out-instellingen"
            ],
			"Messaging": [],
            "Gamification": [
                "Nieuw type uitdaging: Gevechtsboten"
            ],
            "Coaching": [
                "Kolommen toevoegen aan de coaching-beheerdersrapportpagina",
                "Voeg vervaldatum toe als optioneel veld in coachingsessie",
                "Voeg een vervaldatum toe als optioneel veld voor taken binnen de coachingsessie",
                "Stuur e-mailmeldingen over coachingevenementen",
                "Nieuwe kolom voor de naam van de coachingsessie en filter voor achterstallige taken en exportoptie",
                "Formulierpagina-update (antwoordtype met meerdere selecties)"
            ], 
			"QA": [],
            "Dashboards": [
                "Verbeteringen van vooraf ingestelde datums in de widget: Gregoriaanse kalenderweergave",
                "Nieuwe widget: Mijn rangschikkingswidget",
                "Gestandaardiseerde initiële widgetbelasting",
                "Bijgewerkte publicatiebalkcomponent",
                "Hiërarchietoewijzing: nieuwe kolommen toegevoegd",
                "Datumbereikupdate - Rollend jaar tot rollende 12 maanden"
            ],
            "Wallboards": [
                "Wallboards Hoekconversie Weergave/Diavoorstelling"
            ]
			},
		"DirectNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"NiceInContactNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"Five9Notes": 
			{
			"General": [
			],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"SerenovaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"GenesysNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"CiscoNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AmazonNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AvayaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"UJetNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			}
	},
	"Japanese": {
		"Greetings": "期待できること", 
		"releaseVersion": "リリース 24.4",
		"acknowledge": "ありがとう",
		"General": "一般的な", 
		"Messaging": "Messagerie", 
		"Gamification": "ゲーミフィケーション", 
		"Coaching": "Entraînement", 
		"QA": "質疑応答", 
		"Dashboards": "ダッシュボード", 
		"Wallboards": "ウォールボード",
		"Notes": 
			{
            "General": [
                "階層エクスポート",
                "サブスクリプションの強化",
                "旧モーダルウィジェット設定のサポート終了 – スライドアウト設定に置き換えられました"
            ],
			"Messaging": [],
            "Gamification": [
                "新しいチャレンジタイプ: 戦闘艇"
            ],
            "Coaching": [
                "コーチング管理レポートページに列を追加する",
                "コーチングセッションのオプションフィールドとして期日を追加する",
                "コーチングセッション内のタスクにオプションフィールドとして期限を追加する",
                "コーチングイベントに関するメール通知を送信する",
                "新しいコーチングセッション名列と期限切れタスクのフィルターとエクスポートオプション",
                "フォームページの更新 (複数選択回答タイプ)"
            ], 
			"QA": [],
            "Dashboards": [
                "ウィジェットのプリセット日付の改善: グレゴリオ暦ビュー",
                "新しいウィジェット: マイランキングウィジェット",
                "標準化された初期ウィジェット読み込み",
                "更新された公開バーコンポーネント",
                "階層マッピング: 新しい列が追加されました",
                "日付範囲の更新 - 1 年間から 12 か月まで"
            ],
            "Wallboards": [
                "ウォールボード角度変換ビュー/スライドショー"
            ]
			},
		"DirectNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"NiceInContactNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"Five9Notes": 
			{
			"General": [
			],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"SerenovaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"GenesysNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"CiscoNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AmazonNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"AvayaNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			},
		"UJetNotes": 
			{
			"General": [],
			"Messaging": [], 
			"Gamification": [], 
			"Coaching": [], 
			"QA": [], 
			"Dashboards": [], 
			"Wallboards": []
			}
	}
}